import { QueryHookOptions, useQuery } from '@apollo/client'
import { GET_LOT_WITH_ID } from '@graphql/queries/getLotWithId.query'
import { BookingGetLotQuery, BookingGetLotQueryVariables } from 'parkdepot-shared/gql/graphql'

const useBookingGetLotById = (opts: QueryHookOptions<BookingGetLotQuery, BookingGetLotQueryVariables>) => {
    return useQuery(GET_LOT_WITH_ID, opts)
}

export default useBookingGetLotById
